// extracted by mini-css-extract-plugin
module.exports = {"focus-point-container":"focus-point-container--Y2ihBktInb","focusPointContainer":"focus-point-container--Y2ihBktInb"};